import {
    setStore,
    removeStore
} from '@/utils/store'
import {
    getEtquestiontypeList
} from '@/api/exam/etquestiontype'

const mutations = {
    SET_LANGUAGE: (state, language) => {
        state.language = language
        setStore({
            name: 'language',
            content: state.language
        })
    },
    SET_LOGIN_VISIBLE: (state, visible) => {
        state.loginVisible = visible
    },
    SET_PULSE_LOADER: (state, visible) => {
        state.pulseLoader = visible
    },
    SET_SHADE: (state, active) => {
        state.isShade = active
    },
    SET_COLLAPSE: (state) => {
        state.isCollapse = !state.isCollapse
    },
    SET_FULLSCREN: (state) => {
        state.isFullScren = !state.isFullScren
    },
    SET_LOCK: (state) => {
        state.isLock = true
        setStore({
            name: 'isLock',
            content: state.isLock,
            type: 'session'
        })
    },
    SET_SCREEN: (state, screen) => {
        state.screen = screen
    },
    SET_COLOR_NAME: (state, colorName) => {
        state.colorName = colorName
        setStore({
            name: 'colorName',
            content: state.colorName,
        })
    },
    SET_THEME_NAME: (state, themeName) => {
        state.themeName = themeName
        setStore({
            name: 'themeName',
            content: state.themeName,
        })
    },
    SET_LOCK_PASSWD: (state, lockPasswd) => {
        state.lockPasswd = lockPasswd
        setStore({
            name: 'lockPasswd',
            content: state.lockPasswd,
            type: 'session'
        })
    },
    SET_REFRESH: (state, update) => {
        state.isRefresh = update
        localStorage.setItem('isRefresh', update)
    },
    CLEAR_LOCK: (state) => {
        state.isLock = false
        state.lockPasswd = ''
        removeStore({
            name: 'lockPasswd',
            type: 'session'
        })
        removeStore({
            name: 'isLock',
            type: 'session'
        })
    },
    SET_CURRENT_EXP_INFO: (state, curExp) => {
        state.curExp = curExp
        if (curExp) {
            setStore({
                name: 'retainExp',
                content: curExp
            })
        } else {
            removeStore({
                name: 'retainExp'
            })
        }
    },
    SET_QUESTION_TYPE_LIST: (state, {
        token
    }) => {
        if (token) {
            getEtquestiontypeList().then(list => {
                state.questionTypeList = list
            })
        } else {
            state.questionTypeList = []
        }
    }
}

export default mutations